import React from "react";
import {
  fullscreenOuter,
  fullscreenBanner,
  bannerContent,
  sunsetText,
  helloRewardsImage,
  travelPassImage,
} from "./GoNativeSunsetBanner.module.scss";
import { StaticImage } from "gatsby-plugin-image";
const GoNativeSunsetBanner: React.FC = () => {
  return (
    <div className={fullscreenOuter}>
      <div className={fullscreenBanner}>
        <div className={bannerContent}>
          <StaticImage
            src={"../../../../src/images/rlhHellorewards.png"}
            alt="hello rewards logo"
            className={helloRewardsImage}
            layout="fixed"
            formats={["png", "webp"]}
            height={202}
            width={202}
          />
          <div className={sunsetText}>
            Hello Rewards members are now enrolled in Sonesta Travel Pass. Find
            hotels, reserve stays, and manage your account on sonesta.com or
            download the Sonesta mobile app.
          </div>
          <svg
            className={travelPassImage}
            id="travel-pass-logo"
            style={{ height: "165px", width: "294px" }}
          >
            <use xlinkHref="/svg/travel-pass-new-logo.svg#travel-pass-new-logo">
              {" "}
            </use>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default GoNativeSunsetBanner;
